import React, { useState, useEffect } from 'react';
import Replay from './Replay';
import StressTest from './StressTest'
import AlgoCorrelation from '../algos/AlgoCorrelation'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AlgoRobustness from '../algos/AlgoRobustness';
import LiveVsBacktest from "./LiveVsBacktest.js"
import PlanMetrics from './PlanMetrics.js';
import { useParams } from 'react-router-dom';
import PlanCorrelations from './PlanCorrelations.js';
import CircuitBreakerAnalysis from './CircuitBreakerAnalysis.js';
import PlanXRay from './PlanXRay.js';
import PlanRegimes from './PlanRegimes.js';
import PlanCompare from './PlanCompare.js';
import TradeNotes from '../trades/TradeNotes.js';
import PlanDiversification from './PlanDiversification.js';


function PlanAnalysis(props) {

    let { activeTab } = useParams();

    const [tab, setTab] = useState(activeTab ? activeTab : 'metrics');

    useEffect(() => {
        if (activeTab) {
            setTab(activeTab);
        }
    }, [activeTab]);

    function shouldAllow() {
        return (props.role >= 1);
    }

    const handleChangeTab = (event, newTab) => {
        setTab(newTab);
    };


    return (
        <div>
            {shouldAllow() ?
                <>
                    <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                        <Tabs
                            value={tab}
                            onChange={handleChangeTab}
                            textColor="secondary"
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="metrics" label="Metrics" />
                            <Tab value="diversification" label="Diversification" />
                            <Tab value="robustness" label="Robustness" />
                            <Tab value="regimes" label="Regimes" />
                            <Tab value="circuitbreaker" label="Max Drawdowns" />
                            <Tab value="livevsbacktest" label="Live vs Backtest" />
                            <Tab value="notes" label="Trade Notes" />
                            <Tab value="xray" label="X Ray" />
                            <Tab value="plancompare" label="Compare" />
                            <Tab value="montecarlo" label="Monte Carlo" />
                            <Tab value="plancorrelations" label="Correlation Grid" />
                            <Tab value="correlations" label="Algo Comparison" />
                            <Tab value="replay" label="Replay" />
                        </Tabs>
                    </Box>
                    <br></br>

                    {tab === "metrics" ?
                        <>
                            <PlanMetrics planId={props.planId} userId={props.userId} role={props.role} />
                        </>
                        : null}
                    {tab === "diversification" ?
                        <>
                            <PlanDiversification planId={props.planId} userId={props.userId} role={props.role} mobileView={props.mobileView} />
                        </>
                        : null}
                    {tab === "notes" ?
                        <>
                            <TradeNotes planId={props.planId} userId={props.userId} role={props.role} />
                        </>
                        : null}

                    {tab === "circuitbreaker" ?
                        <>
                            <CircuitBreakerAnalysis planId={props.planId} userId={props.userId} role={props.role} />
                        </>
                        : null}
                    {tab === "xray" ?
                        <>
                            <PlanXRay planId={props.planId} userId={props.userId} role={props.role} />
                        </>
                        : null}
                    {tab === "regimes" ?
                        <>
                            <PlanRegimes planId={props.planId} userId={props.userId} role={props.role} />
                        </>
                        : null}
                    {tab === "replay" ?
                        <>
                            <Replay planId={props.planId} />
                        </>
                        : null}
                    {tab === "montecarlo" ?
                        <>
                            <StressTest planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                        </>
                        : null}
                    {tab === "correlations" ?
                        <>
                            <AlgoCorrelation planId={props.planId} onAlgoSelected={props.onAlgoSelected} />
                        </>
                        : null}

                    {tab === "robustness" ?
                        <>
                            <AlgoRobustness mobileView={props.mobileView} planId={props.planId} role={props.role} />
                        </>
                        : null}
                    {tab === "livevsbacktest" ?
                        <>
                            <LiveVsBacktest planId={props.planId} />
                        </>
                        : null}
                    {tab === "plancorrelations" ?
                        <>
                            <PlanCorrelations planId={props.planId} />
                        </>
                        : null}
                    {tab === "plancompare" ?
                        <>
                            <PlanCompare planId={props.planId} userId={props.userId} />
                        </>
                        : null}

                </>
                :
                <div class="empty-page" >Not allowed</div>
            }


        </div>
    );
}

export default PlanAnalysis;